import './assets/css/App.css';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { AuthProvider } from 'contexts/auth.context';
import App from './App';
import { Provider } from 'react-redux';
import store from './store/store';
import './utils/hooks/fetch-interceptor';

const root = ReactDOM.createRoot(document.getElementById('root'));
let user: any = localStorage.getItem('user');
user = JSON.parse(user);

root.render(
  <Provider store={store}>
    <AuthProvider userData={user}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </AuthProvider>
  </Provider>,
);
